/**
 * Constrains the structure of an object to conform with a standard theme set as defined by the styling system.
 */
export function asSingleStyleConfig(theme) {
  return theme;
}

/**
 * Constrains the structure of an object to conform with the component parts structure as defined by the styling system.
 */
export function asMultiStyleConfig(theme) {
  return theme;
}